module.exports = __webpack_public_path__ + "static/media/projectPic3.103f338e.png";